<template>
  <v-container>
    <v-row>
      <v-col cols="7" align="right">
        <TextButton
          class="secondary ui-module-btn-solid ui-module-fade-in-up py-y mt-2 px-8"
          rounded
          elevation="8"
          to="/equipamiento/registro_item"
          >Nuevo item <v-icon small class="ml-2">mdi-plus</v-icon></TextButton
        >
      </v-col>
      <v-col cols="12" lg="5">
        <v-text-field
          class="ui-form-field"
          v-model="buscaItem"
          color="secondary"
          background-color="transparent"
          rounded
          filled
          hide-details
          placeholder="Buscar item por nombre..."
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaItem.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredItems.length }} resultados encontrados con la búsqueda "{{ buscaItem }}"
        </div>
      </v-col>
      <v-expansion-panels flat class="ui-module-card" focusable hover mandatory>
        <v-expansion-panel v-for="(grupoItems, index) in groupedItems" :key="index">
          <v-expansion-panel-header>
            <div>
              <div class="text-h6 secondary--text font-weight-bold d-inline">
                {{ grupoItems.tipo }}
              </div>
              <div class="text-overline d-inline secondary--text">({{ grupoItems.items.length }})</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-container>
              <v-row>
                <v-col cols="12" lg="4" xl="3" v-for="item in grupoItems.items" :key="item.id">
                  <v-card class="ui-module-card" color="secondary" elevation="8">
                    <v-card-title class="justify-center text-center py-6">
                      <div class="text-h6 primary--text font-weight-bold text-left" style="width: 100%">
                        {{ item.item }}
                      </div>
                    </v-card-title>
                    <v-card-text class="py-0"></v-card-text>
                    <v-card-actions class="secondary darken-1 ui-module-actions">
                      <v-container>
                        <v-row>
                          <v-col cols="12" align="right">
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="primary secondary--text mx-2 ui-module-icon-action"
                                  elevation="8"
                                  :to="{ name: 'listaMovimientos', params: { id: item.id } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-clipboard</v-icon></v-btn
                                >
                              </template>
                              <span>Ver movimientos e inventario</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="primary secondary--text mx-2 ui-module-icon-action"
                                  elevation="8"
                                  :to="{ name: 'movimientoEquipamiento', params: { id: item.id } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-clipboard-flow-outline</v-icon></v-btn
                                >
                              </template>
                              <span>Realizar movimiento de inventario</span>
                            </v-tooltip>
                            <v-tooltip bottom color="black">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="primary secondary--text mx-2 ui-module-icon-action"
                                  elevation="8"
                                  :to="{ name: 'editarItem', params: { id: item.id } }"
                                  icon
                                  v-on="on"
                                  v-bind="attrs"
                                  ><v-icon>mdi-pencil</v-icon></v-btn
                                >
                              </template>
                              <span>Editar item</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  data() {
    return {
      buscaItem: '',
      ordenAlfabetico: 0,
    }
  },

  computed: {
    ...mapGetters('item', {
      items: 'getItems',
    }),

    filteredItems: function () {
      return this.items.filter((item) => {
        return item.item.toLowerCase().indexOf(this.buscaItem.toLowerCase()) >= 0
      })
    },

    groupedItems: function () {
      var result = _(this.filteredItems)
        .groupBy((item) => item.CatTipoItem.title)
        .map((items, tipo) => ({ tipo, items }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.tipo < b.tipo) {
            return -1
          }
          if (a.tipo > b.tipo) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.tipo > b.tipo) {
            return -1
          }
          if (a.tipo < b.tipo) {
            return 1
          }
          return 0
        })
      }
      return result
    },
  },
}
</script>

<style scoped>
/* Títulos y textos */
.text-h6 {
  color: #e0e0e0 !important;
  font-weight: 700;
}

.secondary--text {
  color: #ffbe76 !important;
}

.primary--text {
  color: #e0e0e0 !important;
}

/* Input de búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(255, 190, 118, 0.75) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #ffbe76 !important;
}

/* Botón toggle de orden */
::v-deep .v-btn-toggle {
  background: rgba(46, 36, 22, 0.6) !important;
  border: 1px solid rgba(255, 159, 67, 0.2);
}

::v-deep .v-btn-toggle .v-btn {
  border-radius: 12px !important;
}

::v-deep .v-btn-toggle .v-btn--active {
  background: rgba(255, 159, 67, 0.2) !important;
}

/* Expansion Panels */
::v-deep .v-expansion-panel {
  background: rgba(46, 36, 22, 0.4) !important;
  border: 1px solid rgba(255, 159, 67, 0.15);
  border-radius: 16px !important;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

::v-deep .v-expansion-panel:hover {
  background: rgba(46, 36, 22, 0.6) !important;
  border-color: rgba(255, 159, 67, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.2);
}

::v-deep .v-expansion-panel-header {
  color: #e0e0e0 !important;
  padding: 20px 24px;
  border-radius: 16px !important;
}

::v-deep .v-expansion-panel-header:hover {
  background: rgba(255, 159, 67, 0.08) !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 16px 24px 24px;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(255, 159, 67, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: #ff9f43;
  box-shadow: 0 8px 24px rgba(255, 159, 67, 0.4);
}

::v-deep .v-btn.primary {
  background: rgba(46, 36, 22, 0.8) !important;
  border: 1px solid rgba(255, 159, 67, 0.3);
}

::v-deep .v-btn.primary:hover {
  background: rgba(46, 36, 22, 0.95) !important;
  border-color: #ff9f43;
}

::v-deep .v-btn icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(46, 36, 22, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
